import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Instrukcije from './pages/Instrukcije';
import Skripte from './pages/Skripte';
import FAQ from './pages/FAQ';
import Kontakt from './pages/Kontakt';
import PravilaPrivatnosti from './pages/PravilaPrivatnosti';
import './App.css';

// No need to preload images - let them load naturally

// ScrollToTop component to handle scrolling on route changes
function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const prevPathnameRef = React.useRef(pathname);

  useEffect(() => {
    // If there's a hash in the URL, scroll to that element after a short delay
    if (hash) {
      setTimeout(() => {
        const element = document.getElementById(hash.substring(1));
        if (element) {
          // Get header height to offset scroll position
          const header = document.querySelector('.main-header');
          const headerHeight = header ? header.offsetHeight : 80;
          
          // Single precise scroll calculation to position section content lower on screen
          const elementTop = element.offsetTop;
          const targetPosition = elementTop - headerHeight + 85; // Much larger offset to position content lower
          
          // Ensure we don't scroll to negative positions
          const finalPosition = Math.max(0, targetPosition);
          
          window.scrollTo({
            top: finalPosition,
            behavior: 'smooth'
          });
 
        }
      }, 250);
    } else {
      // Only scroll to top if we actually changed pages (not just navigating to sections)
      if (prevPathnameRef.current !== pathname) {
        // Force scroll to top for all browsers, especially Firefox
        window.scrollTo(0, 0);
        
        // Additional fix for Firefox on specific pages
        if (pathname === '/kontakt' || pathname === '/skripte') {
          // Set data attribute for CSS targeting
          document.body.setAttribute('data-page', pathname.substring(1));
          
          // Use requestAnimationFrame for better timing
          const scrollToTop = () => {
            window.scrollTo(0, 0);
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
          };
          
          // Immediate attempt
          scrollToTop();
          
          // Multiple attempts with different timing
          requestAnimationFrame(() => {
            scrollToTop();
            setTimeout(scrollToTop, 50);
            setTimeout(scrollToTop, 150);
            setTimeout(scrollToTop, 300);
          });
        } else {
          // Remove data attribute for other pages
          document.body.removeAttribute('data-page');
        }
      }
    }
    
    // Update the previous pathname
    prevPathnameRef.current = pathname;
  }, [pathname, hash]);

  return null;
}

// Loading screen removed for better performance

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <ScrollToTop />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/instrukcije" element={<Instrukcije />} />
              <Route path="/skripte" element={<Skripte />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/kontakt" element={<Kontakt />} />
              <Route path="/pravila-privatnosti" element={<PravilaPrivatnosti />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
